import { initDetailsAccordion } from 'utils/details-accordion'

function initBrandsAccordion($root: HTMLElement): void {
  const $hasBrands = $root.querySelector('[data-js="esim-devices-brand"]') !== null
  if (!$hasBrands) return

  initDetailsAccordion($root, '[data-js="esim-devices-brand"]')
}

export function initEsimDevices($root: HTMLElement): void {
  const $tabs = Array.from($root.querySelectorAll<HTMLButtonElement>('[role="tab"]'))
  const $panels = Array.from($root.querySelectorAll<HTMLElement>('[role="tabpanel"]'))

  initBrandsAccordion($root)

  function activateTab($targetTab: HTMLButtonElement): void {
    const targetKey = $targetTab.dataset.tab

    $tabs.forEach(($tab) => {
      const isActive = $tab === $targetTab
      $tab.setAttribute('aria-selected', String(isActive))
      $tab.classList.toggle('button--transparent', !isActive)
    })

    $panels.forEach(($panel) => {
      const isActive = $panel.id === `esim-devices-panel-${targetKey}`
      $panel.classList.toggle('is-active', isActive)
      if (isActive) {
        $panel.removeAttribute('hidden')
      } else {
        $panel.setAttribute('hidden', '')
      }
    })
  }

  $tabs.forEach(($tab) => {
    $tab.addEventListener('click', () => activateTab($tab))
  })
}
